import moment from 'moment';

export interface DueLabelResult {
    label: string;
    isOverdue: boolean;
}

// Shared by the three "X due" widgets (Enquiry follow-ups due, Contact follow-ups due,
// Tasks due) - a plain-English relative label ("Overdue by 2d", "Due today", "Due 12 Aug")
// rather than a raw date, since these are already filtered server-side to "today and
// earlier" (todayAndEarlier), so everything shown here is either overdue or due today by
// construction - a future date should never actually reach this, but it's handled anyway
// rather than assumed away.
export function formatDueLabel(dueDate: string | Date | null): DueLabelResult {
    if (!dueDate) {
        return { label: 'No due date', isOverdue: false };
    }

    const due = moment(dueDate).startOf('day');
    const today = moment().startOf('day');
    const daysDiff = today.diff(due, 'days');

    if (daysDiff > 0) {
        return { label: `Overdue by ${daysDiff}d`, isOverdue: true };
    }
    if (daysDiff === 0) {
        return { label: 'Due today', isOverdue: true };
    }
    return { label: `Due ${due.format('D MMM')}`, isOverdue: false };
}
